import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useMobileMenu } from '@/hooks/useMobileMenu'

const primaryNavLinks = [
  { label: 'Inicio', href: '/' },
  { label: 'Quienes Somos', href: '/quienes-somos' },
  { label: 'Consultas', href: '/consultas' },
  { label: 'Dr Horcon', href: '/asistente-ia' },
  { label: 'Contacto', href: '/contacto' },
]

const secondaryNavLinks = [
  { label: 'Medicina Preventiva', href: '/medicina-preventiva' },
  { label: 'Atención por Especie', href: '/atencion-por-especie' },
  { label: 'Cirugía', href: '/cirugia' },
  { label: 'Internación y Cuidados', href: '/internacion-y-cuidados' },
  { label: 'Enfermería', href: '/enfermeria' },
  { label: 'Laboratorio', href: '/laboratorio-basico' },
  { label: 'Dermatología', href: '/dermatologia' },
  { label: 'Odontología', href: '/odontologia' },
  { label: 'Producción Animal', href: '/produccion-animal' },
  { label: 'Bromatología', href: '/bromatologia' },
  { label: 'Bienestar y Asesoramiento', href: '/bienestar-y-asesoramiento' },
  { label: 'Cursos', href: '/cursos' },
]

const contactLinks = [
  { label: 'Teléfono', value: '+54 299 672-7809', href: 'tel:+542996727809', icon: 'ph-phone' },
  { label: 'Email', value: 'elhorconcriollo@gmail.com', href: 'mailto:elhorconcriollo@gmail.com', icon: 'ph-envelope' },
  { label: 'Instagram', value: '@Elhorconcriollo', href: 'https://instagram.com/Elhorconcriollo', icon: 'ph-instagram-logo' },
]

function Header() {
  const { isOpen, setIsOpen, toggleMenu, menuRef, buttonRef } = useMobileMenu()
  const location = useLocation()

  useEffect(() => {
    setIsOpen(false)
  }, [location.pathname])

  const isAdmin = location.pathname.startsWith('/admin')

  if (isAdmin) return null

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-16 md:h-20 bg-background/80 backdrop-blur-md border-b border-gray-200/50 glass-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2 text-primary hover:text-primary-dark transition-colors">
          <img src="/Docs/Fotos/Logo recortado.png" alt="Logo El Horcon Criollo" className="h-8 w-8" />
          <span className="hidden md:block font-bold text-lg">El Horcon Criollo</span>
        </Link>

        <nav className="hidden md:block">
          <ul className="flex space-x-2">
            {primaryNavLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="px-3 py-2 text-sm font-medium text-text-primary hover:text-primary transition-colors"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="hidden md:flex items-center space-x-4">
          <div className="flex items-center space-x-4 text-sm text-text-secondary">
            {contactLinks.map((link) => (
              <a key={link.label} href={link.href} className="hover:text-primary transition-colors" aria-label={link.label}>
                <i className={`${link.icon} text-base`}></i>
              </a>
            ))}
          </div>
        </div>

        <button
          ref={buttonRef}
          onClick={toggleMenu}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          aria-label="Toggle menu"
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
        >
          <i className={isOpen ? 'ph ph-x text-2xl' : 'ph ph-list text-2xl'}></i>
        </button>
      </div>

      {isOpen && (
        <div
          ref={menuRef}
          id="mobile-menu"
          className="absolute top-full left-0 right-0 md:left-auto md:right-0 md:w-full md:max-w-2xl max-h-[calc(100vh-4rem)] overflow-y-auto bg-background/95 backdrop-blur-md border-b border-gray-200 shadow-lg"
        >
          <nav className="px-4 py-2">
            <ul className="space-y-1">
              {primaryNavLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="block px-3 py-2 text-base font-medium text-text-primary hover:text-primary hover:bg-gray-50 rounded transition-colors"
                    onClick={() => setIsOpen(false)}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <ul className="space-y-1 mt-2">
              {secondaryNavLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="block px-3 py-2 text-base font-medium text-text-primary hover:text-primary hover:bg-gray-50 rounded transition-colors"
                    onClick={() => setIsOpen(false)}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      )}
    </header>
  )
}

export default Header